import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getUserProfile } from '../../services/userService';

// Puedes ajustar esto según cómo guardes el token
function isLoggedIn() {
	return Boolean(localStorage.getItem('firebaseToken'));
}

const PrivateRoute: React.FC = () => {
	const [status, setStatus] = useState<
		'LOADING' | 'ACTIVO' | 'INACTIVO' | 'ERROR'
	>('LOADING');

	useEffect(() => {
		if (!isLoggedIn()) {
			setStatus('INACTIVO');
			return;
		}
		getUserProfile()
			.then((user) => {
				if (user.status === 'ACTIVO') {
					setStatus('ACTIVO');
				} else {
					setStatus('INACTIVO');
				}
			})
			.catch(() => setStatus('ERROR'));
	}, []);

	if (status === 'LOADING') return null; // O spinner
	if (status === 'ACTIVO') return <Outlet />;
	return <Navigate to="/login" replace />;
};

export default PrivateRoute;
